import React, { ReactNode } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { accordionBoxComponentStyles } from './style';
import { useTranslation } from 'react-i18next';
import { getResponsiveSize } from '../../../utils';

interface AccordionBoxComponentProps {
  title: string;
  children?: ReactNode;
  className: string;
  tooltip?: string;
  tooltipPosition?: any;
}

export const AccordionBoxComponent = (props: AccordionBoxComponentProps) => {
  const { title, children, className, tooltip = '', tooltipPosition } = props;
  const { accordionBoxComponent } = accordionBoxComponentStyles;
  const { t } = useTranslation();

  const titleContainer = (
    <Box className="title-container">
      <Typography className="title">{title}</Typography>
    </Box>
  );

  return (
    <Box sx={accordionBoxComponent}>
      {tooltip ? (
        <Tooltip
          placement={tooltipPosition}
          disableInteractive
          title={
            <Typography
              style={{ fontSize: getResponsiveSize(11) }}
              color="inherit"
              dangerouslySetInnerHTML={{ __html: t(`${tooltip}`) }}
            />
          }
        >
          {titleContainer}
        </Tooltip>
      ) : (
        titleContainer
      )}
      {children}
    </Box>
  );
};
